export const DETAIL_DESCRIPTION_CONFIG = {
  xs: 1,
  sm: 1,
  md: 1,
  lg: 2,
  xl: 2,
  xxl: 2,
} as const;
